import { cn } from '../libs/cn';

/* global gtag */

const trackEvent = (eventName, params = {}) => {
    if (typeof gtag !== 'undefined') {
        gtag('event', eventName, params);
    } else {
        console.warn('Google Analytics is not initialized');
    }
};

const Button = ({ children, className, label, ...props }) => {
    const handleClick = (e) => {
        if (props.onClick) props.onClick(e);

        // Відправка події в Google Analytics
        trackEvent('button_click', {
            event_category: 'Button',
            event_label: label || 'Unnamed Button',
        });
    };

    return (
        <button
            className={cn('btn', className)}
            {...props}
            onClick={handleClick}
        >
            {children}
        </button>
    );
};

export default Button;
